export const SET_USER_ID = 'SET_USER_ID';
export const SET_USER_AUTHENTICATION = 'SET_USER_AUTHENTICATION';
export const SET_USER_PROFIL = 'SET_USER_PROFIL';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const SET_USER = 'SET_USER';

export default {
    SET_USER_ID,
    SET_USER_AUTHENTICATION,
    SET_USER_PERMISSIONS,
    SET_USER_PROFIL,
    SET_USER,
};